export const disabledRefreshPlacementStatus = [
  {
    activityStatusId: 4,
    activityStatus: 'Declined by Traveler',
  },
  {
    activityStatusId: 5,
    activityStatus: 'Declined by Facility',
  },
  {
    activityStatusId: 7,
    activityStatus: 'Request Cancelled',
  },

  {
    activityStatus: 'Canceled By Traveler',
    activityStatusId: 20,
  },
  {
    activityStatus: 'Canceled By Facility',
    activityStatusId: 21,
  },
  {
    activityStatus: 'Canceled by AMH',
    activityStatusId: 22,
  },
  {
    activityStatus: 'Canceled by Settlement',
    activityStatusId: 28,
  },
  {
    activityStatus: 'Canceled By Traveler',
    activityStatusId: 25,
  },
  {
    activityStatus: 'Canceled By Facility',
    activityStatusId: 26,
  },
  {
    activityStatus: 'Canceled by AMH',
    activityStatusId: 27,
  },
  {
    activityStatus: 'Canceled by Settlement',
    activityStatusId: 29,
  },
  {
    activityStatus: 'Assignment Complete',
    activityStatusId: 24,
  },
  {
    activityStatus: 'Waiting for Clearance',
    activityStatusId: 1,
  },
];
